import { render, staticRenderFns } from "./AiChatPanel.vue?vue&type=template&id=5c7e550e&scoped=true"
import script from "./AiChatPanel.vue?vue&type=script&lang=js"
export * from "./AiChatPanel.vue?vue&type=script&lang=js"
import style0 from "./AiChatPanel.vue?vue&type=style&index=0&id=5c7e550e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7e550e",
  null
  
)

export default component.exports